import { BadRequestError } from '../../utils/badRequestError';
import { IApplicationContext } from '../../types/applicationContext';

import {
  fetchCreateMessageForAddform,
  ICreateMessageForAddformRequest,
  ICreateMessageForAddformResponse200 as IRes200,
  ICreateMessageForAddformResponse400 as IRes400,
} from '../../repositories/demand/v2/create-message-for-addform';

interface ICreateMessageForAddFormProps {
  context: IApplicationContext;
  parameters: ICreateMessageForAddformRequest;
}

export const createMessageForAddForm = async ({ context, parameters }: ICreateMessageForAddFormProps) => {
  const { httpApi, logger } = context;

  try {
    const res = await fetchCreateMessageForAddform<IRes200, IRes400>({
      httpApi,
      parameters,
    });

    if (res.statusCode !== 200) {
      throw new BadRequestError({
        message: res.response.message,
        domain: 'createMessageForAddForm.ts',
        details: {
          errors: res.response.errors,
        },
      });
    }

    return res.response;
  } catch (e) {
    if (!(e instanceof BadRequestError)) {
      logger.error('Ошибка при создании заявки', {
        message: e.message,
        domain: 'createMessageForAddForm.ts',
      });
    }

    throw e;
  }
};
